import { App } from '../App';

/**
 * Experience — the `/` route. IS the 3D app composed in Plan 03-04:
 * <PlausibleProvider><SourcesLoader /><ErrorBoundary><NavController>
 *   <Renderer /><UIShell /></NavController></ErrorBoundary></PlausibleProvider>.
 *
 * This wrapper exists so the router.tsx imports look uniform (every route is
 * a component in ./routes/). Do NOT modify App.tsx from this plan — routing
 * is strictly additive to the Phase 3-6 composition.
 */
export function Experience() {
  return <App />;
}
